// extracted by mini-css-extract-plugin
export default {"closeButton":"styles_closeButton__oYMC1","modalBody":"styles_modalBody__GqzpJ"};